@if (!isPreview) {
  <section class="astral-stack-l">
    <div class="header">
      <h1>{{ 'PROPERTY_TAX.FEE_CHANGE.HEADER' | translate }}</h1>
      <button class="btn btn-active btn-list-header" (click)="preview()">{{ 'PREVIEW_BTN' | translate }}</button>
    </div>
    <section class="astral-section-surface astral-form-stack" [formGroup]="form">
      <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1">
        <astral-toggle [control]="form.controls['useRetroactiveRent']"></astral-toggle>
        @if (form.controls['useRetroactiveRent'].value) {
          <astral-input type="number" [control]="form.controls['retroactiveMonths']"></astral-input>
        }
      </astral-layout-group>
      @if (form.controls['useRetroactiveRent'].value) {
        <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1">
          <astral-checkbox
            [control]="form.controls['changeInvoiceText']"
            [helpText]="'LEASE_AGREEMENT.HELP_TEXT.RENTAL_CHANGES_USE_CHANGE_INVOICETEXT'"
          ></astral-checkbox>
          @if (form.controls['changeInvoiceText'].value) {
            <astral-input
              [control]="form.controls['newInvoiceText']"
              [helpText]="'LEASE_AGREEMENT.HELP_TEXT.RENTAL_CHANGES_NEW_INVOICETEXT'"
            ></astral-input>
          }
        </astral-layout-group>
      }
    </section>
    <section class="astral-stack-m">
      <div class="astral-filter-actions">
        <h4>{{ 'PROPERTY_TAX.FEE_CHANGE.CHANGED_AGREEMENTS' | translate }}</h4>
        <astral-button
          variant="secondary"
          size="small"
          type="button"
        [labelKey]="showLeaseAgreementList
          ? 'PROPERTY_TAX.FEE_CHANGE.HIDE_AGREEMENTS_LIST'
          : 'PROPERTY_TAX.FEE_CHANGE.SHOW_AGREEMENTS_LIST'"
          (click)="toggleLeaseAgreementList()"
        ></astral-button>
      </div>
      <app-filter [filters]="filterDefinition" (change)="onLeaseAgreementFilterChange($event)" [defaultFilters]="defaultFilters"></app-filter>
      @if (showLeaseAgreementList) {
        <app-multiselect-list-view
          [itemsSource]="leaseAgreementChangeRows"
          [columnDefinition]="rentalChangeColumnDefinitions"
          [selectAll]="false"
        ></app-multiselect-list-view>
      }
    </section>
    <section class="astral-stack-m">
      <div class="astral-filter-actions">
        <h4>{{ 'PROPERTY_TAX.FEE_CHANGE.CHANGED_OBJECTS' | translate }}</h4>
        <astral-button
          variant="secondary"
          size="small"
          type="button"
        [labelKey]="showRentalObjectList
          ? 'PROPERTY_TAX.FEE_CHANGE.HIDE_OBJECTS_LIST'
          : 'PROPERTY_TAX.FEE_CHANGE.SHOW_OBJECTS_LIST'"
          (click)="toggleRentalObjectList()"
        ></astral-button>
      </div>
      @if (showRentalObjectList) {
        <app-multiselect-list-view
          [itemsSource]="rentalObjectChangeRows"
          [columnDefinition]="objectRentalChangeColumnDefinitions"
          [selectAll]="false"
        ></app-multiselect-list-view>
      }
    </section>
  </section>
}

@if (isPreview) {
  <section class="astral-stack-l">
    @if (previewLeases) {
      <section class="astral-stack-m">
        <h1 class="header list-header">{{ 'PROPERTY_TAX.FEE_CHANGE.CHANGED_AGREEMENTS' | translate }}</h1>
        <app-list-view [itemsSource]="rentalChanges" [columnDefinition]="previewRentalChangeColumnDefinitions"></app-list-view>
      </section>
    }
    @if (previewClosedLeases) {
      <section class="astral-stack-m">
        <h1 class="header list-header">{{ 'PROPERTY_TAX.FEE_CHANGE.CLOSED_AGREEMENTS' | translate }}</h1>
        <app-list-view
          [itemsSource]="closedLeaseAgreementChanges"
          [columnDefinition]="previewClosedRentalChangeColumnDefinitions"
        ></app-list-view>
      </section>
    }
    @if (previewObjects) {
      <section class="astral-stack-m">
        <h1 class="header list-header">{{ 'PROPERTY_TAX.FEE_CHANGE.CHANGED_OBJECTS' | translate }}</h1>
        <app-list-view [itemsSource]="rentalObjectChanges" [columnDefinition]="previewObjectRentalChangeColumnDefinitions"></app-list-view>
      </section>
    }
    <div class="astral-form-actions astral-form-actions--start">
      @if (canChange) {
        <astral-button
          variant="primary"
          type="button"
          labelKey="SAVE_BTN"
          [disabled]="working"
          (click)="save()"
        ></astral-button>
      }
      <astral-button variant="secondary" type="button" labelKey="CANCEL_BTN" (click)="cancel()"></astral-button>
    </div>
  </section>
}
